import { forwardRef } from 'react'
import { IconElement, IconProps } from 'types/ui'

export const TwitterLogo: IconElement = forwardRef(function TwitterLogo(
  { fill = 'currentColor', ...props }: IconProps,
  ref
) {
  return (
    <svg
      {...props}
      ref={ref}
      width='18'
      height='16'
      viewBox='0 0 18 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.26562 15.3521C3.13936 15.4656 0.785931 14.3006 0 13.7038C2.94287 13.9483 4.86477 12.7651 5.45785 12.1429C3.30091 12.073 2.28138 10.4109 2.04124 9.58861C2.93196 9.75453 3.47483 9.59953 3.63493 9.50128C1.21601 8.95113 0.640388 6.81238 0.654942 5.81178C1.42341 6.28334 2.10309 6.32845 2.34688 6.29207C0.137538 4.65908 0.669497 2.29328 1.21164 1.31451C3.5869 4.4495 7.31716 5.22597 8.88539 5.22233C8.55791 3.36666 9.28927 1.28176 11.6471 0.74689C13.5333 0.318995 14.8272 1.28176 15.2383 1.81663C16.2688 1.70311 17.1813 1.20171 17.5088 0.965204C17.2817 1.88212 16.3808 2.68625 15.9588 2.97369C17.0154 2.9213 17.7599 2.61711 18 2.47157C17.1529 3.67667 16.4172 4.23264 16.1552 4.35999C16.319 12.0665 10.1734 15.2102 6.26562 15.3521Z'
        fill={fill}
      />
    </svg>
  )
})
